import { useEffect, useState } from "react";
import { Box, Button, Checkbox, HStack, useMediaQuery } from "@chakra-ui/react";
import _ from "lodash";

import {
  allConsents,
  communicationAgreement,
  communicationMethods,
  healthAgreement,
  healthProcessingAgreement,
} from "./fixtures";
import { knowledgeAgreement } from "./ui";

export default function ActivityStep({
  setHasRequiredConsents = _.identity,
  setConsents,
  consents: initialConsents,
  requiredConsents,
  hideNonEditable = true,
  hideSelectAll = false,
}: any) {
  const [isLargerThan760] = useMediaQuery("(min-width: 760px)");

  const [knowledge, setKnowledge] = useState(
    initialConsents.knowledge || false
  );
  const [health, setHealth] = useState(initialConsents.health || false);
  const [healthProcessing, setHealthProcessing] = useState(
    initialConsents.healthProcessing || false
  );
  const [email, setEmail] = useState(initialConsents.email || false);
  const [text, setText] = useState(initialConsents.text || false);
  const [call, setCall] = useState(initialConsents.call || false);

  const hasAllOptionalsValuesFilled = email && text && call;
  const hasSomeOptionalsValuesMissing = !email || !text || !call;
  const allOptionalValuesMissing = !email && !text && !call;
  const allConsentsGiven =
    knowledge && health && healthProcessing && email && text && call;

  const isCheckboxDisabled = false;
  const editableProperties = allConsents;

  const displayableProperties = allConsents.filter(
    (propertyName) =>
      !hideNonEditable || editableProperties.includes(propertyName)
  );
  const temporaryConsentsObject = {
    knowledge,
    health,
    healthProcessing,
    email,
    text,
    call,
  };
  const allEditableConsentsGiven = _.every(
    _.pick(temporaryConsentsObject, editableProperties)
  );

  useEffect(() => {
    const consentsObject = {
      knowledge,
      health,
      healthProcessing,
      email,
      text,
      call,
    };
    setHasRequiredConsents(_.every(_.pick(consentsObject, requiredConsents)));
    setConsents(consentsObject);
  }, [knowledge, health, healthProcessing, email, text, call]);

  const Agreement = (text: any, options: any, boxOptions?: any) => {
    return (
      <Checkbox colorScheme="blue" {...options}>
        <Box
          pb={2}
          pl={2}
          {...boxOptions}
          fontSize={isLargerThan760 ? "0.8rem" : "0.7rem"}
        >
          {text}
          {options.isRequired ? <span style={{ color: "red" }}>*</span> : null}
        </Box>
      </Checkbox>
    );
  };

  const CommunicationMethods = () => (
    <>
      {Agreement(communicationMethods.email, {
        isDisabled: isCheckboxDisabled,
        isChecked: email,
        onChange: () => setEmail(!email),
        pl: 0,
        pr: 9,
      })}
      {Agreement(communicationMethods.text, {
        isDisabled: isCheckboxDisabled,
        isChecked: text,
        onChange: () => setText(!text),
        pl: 0,
        pr: 9,
      })}
      {Agreement(communicationMethods.call, {
        isDisabled: isCheckboxDisabled,
        isChecked: call,
        onChange: () => setCall(!call),
        pl: 0,
        pr: 9,
      })}
    </>
  );
  const AgreementsPart = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        {!hideSelectAll && (
          <div>
            <Button
              colorScheme="blue"
              my={3}
              isDisabled={
                isCheckboxDisabled ||
                allConsentsGiven ||
                allEditableConsentsGiven
              }
              onClick={() => {
                if (editableProperties.includes("knowledge"))
                  setKnowledge(true);
                if (editableProperties.includes("health")) setHealth(true);
                if (editableProperties.includes("healthProcessing"))
                  setHealthProcessing(true);
                if (editableProperties.includes("email")) setEmail(true);
                if (editableProperties.includes("text")) setText(true);
                if (editableProperties.includes("call")) setCall(true);
              }}
            >
              Zaznacz wszystkie zgody
            </Button>
          </div>
        )}
        {displayableProperties.includes("knowledge") &&
          Agreement(knowledgeAgreement(), {
            isRequired: true,
            isDisabled:
              isCheckboxDisabled || !editableProperties.includes("knowledge"),
            isChecked: knowledge,
            onChange: () => setKnowledge(!knowledge),
          })}
        {displayableProperties.includes("health") &&
          Agreement(healthAgreement, {
            isRequired: true,
            isDisabled:
              isCheckboxDisabled || !editableProperties.includes("health"),
            isChecked: health,
            onChange: () => setHealth(!health),
          })}
        {displayableProperties.includes("healthProcessing") &&
          Agreement(healthProcessingAgreement, {
            isRequired: true,
            isDisabled:
              isCheckboxDisabled ||
              !editableProperties.includes("healthProcessing"),
            isChecked: healthProcessing,
            onChange: () => setHealthProcessing(!healthProcessing),
          })}
        {(displayableProperties.includes("call") ||
          displayableProperties.includes("email") ||
          displayableProperties.includes("text")) &&
          Agreement(communicationAgreement, {
            isDisabled: isCheckboxDisabled,
            isChecked: email && text && call,
            isIndeterminate:
              !hasAllOptionalsValuesFilled &&
              hasSomeOptionalsValuesMissing &&
              !allOptionalValuesMissing,

            onChange: () => {
              if (!email || !text || !call) {
                setEmail(true);
                setText(true);
                setCall(true);
              } else {
                setEmail(false);
                setText(false);
                setCall(false);
              }
            },
          })}
        {isLargerThan760 ? (
          <HStack spacing={1} pl={8}>
            {(displayableProperties.includes("call") ||
              displayableProperties.includes("email") ||
              displayableProperties.includes("text")) &&
              CommunicationMethods()}
          </HStack>
        ) : (
          (displayableProperties.includes("call") ||
            displayableProperties.includes("email") ||
            displayableProperties.includes("text")) &&
          CommunicationMethods()
        )}
        <div>
          <small style={{ fontSize: "0.6rem" }}>
            {" "}
            <span style={{ color: "red" }}>*</span> zgody wymagane
          </small>
        </div>
      </div>
    );
  };

  return AgreementsPart();
}
